const RetentionSchemaAction = Object.freeze({
  0: 'RetentionAuditLog_Action_Created',
  1: 'RetentionAuditLog_Action_Updated'
})

const RetentionSchemaSection = Object.freeze({
  0: 'RetentionAuditLog_Section_ProfileRetention',
  1: 'RetentionAuditLog_Section_AuditLogRetention'
})

export { RetentionSchemaAction, RetentionSchemaSection }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/RetentionAuditLogEnums.js